import { MensagensService } from 'max-ng-lib';
import {FormGroup} from '@angular/forms';
import {merge} from 'rxjs';
import {map} from 'rxjs/operators';

interface ValidacaoForm {
	form: FormGroup;
	validadoresCampo?: object;
	exclude?: string[];
}

export class ValidacaoHelper {

    constructor(private mensagem: MensagensService) { }

    public setFocoNoElementoDaClasseEExibeMensagem(classe: string, mensagem: string, { elementoPai = document as any } = {}) {
        this.mensagem.exibaToastAlerta(mensagem);
        const elemento = (elementoPai.getElementsByClassName(classe)[0] as any);
        if (elemento) {
            elemento.focus();
        }
    }

    public itemComIdEhValido(modelo: any, propriedade: string): boolean {
        return modelo[propriedade] &&
            modelo[propriedade].id &&
            modelo[propriedade].id > 0;
    }

	public validarFormControl({form, validadoresCampo}: ValidacaoForm, callback: (obj: any) => void) {
		const controlWatchers = Object.entries(form.controls).map(this.mapControl((key) => validadoresCampo[key]));
		merge(...controlWatchers).subscribe(callback);
	}

	mapControl(cb: (key: string) => boolean) {
		return ([key, control]) => cb(key) ? control.valueChanges.pipe(map(value => ({key, value}))) : [];
	}
}
